(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  class IngredientsSwiper extends HTMLElement {
    #transitionTimeout;

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.slideCount = Number(this.dataset.slideCount || this.slides.length);
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;

      if (!this.track || this.slideCount <= 1) {
        this.#setNavDisabled(true);
        return;
      }

      this.#bindEvents();
      this.#render(false);
    }

    disconnectedCallback() {
      if (this.#transitionTimeout) {
        clearTimeout(this.#transitionTimeout);
      }
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
      if (this.blockSelectHandler) {
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }
    }

    #bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.#goTo(this.currentIndex - 1);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.#goTo(this.currentIndex + 1);
        });
      }

      this.handleResize = () => {
        this.#render(false);
      };
      window.addEventListener('resize', this.handleResize);

      this.blockSelectHandler = (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        if (!this.contains(event.target)) return;

        const selectedSlide = event.target.closest('[data-slide]');
        if (!(selectedSlide instanceof HTMLElement)) return;

        const selectedIndex = Number(selectedSlide.dataset.index || 0);
        this.#goTo(selectedIndex, false);
      };
      document.addEventListener('shopify:block:select', this.blockSelectHandler);
    }

    #setNavDisabled(disabled) {
      if (this.prevButton instanceof HTMLButtonElement) {
        this.prevButton.disabled = disabled;
      }
      if (this.nextButton instanceof HTMLButtonElement) {
        this.nextButton.disabled = disabled;
      }
    }

    #goTo(index, animate = true) {
      const maxIndex = this.slideCount - 1;
      if (index < 0) {
        this.currentIndex = maxIndex;
      } else if (index > maxIndex) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }

      this.#render(animate);
    }

    #setSlideState(activeIndex) {
      for (const [index, slide] of this.slides.entries()) {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.classList.remove('is-leaving', 'is-leaving--run', 'is-entering', 'is-entering--run');
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }
    }

    #render(animate = true) {
      const nextIndex = this.currentIndex;
      const previousIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (!animate || previousIndex === -1 || previousIndex === nextIndex) {
        this.#setSlideState(nextIndex);
        return;
      }

      const leavingSlide = this.slides[previousIndex];
      const enteringSlide = this.slides[nextIndex];

      if (this.#transitionTimeout) {
        clearTimeout(this.#transitionTimeout);
      }

      leavingSlide.classList.remove('is-active');
      leavingSlide.classList.add('is-leaving');
      enteringSlide.classList.add('is-entering');
      enteringSlide.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          leavingSlide.classList.add('is-leaving--run');
          enteringSlide.classList.add('is-entering--run');
        });
      });

      const finishTransition = () => {
        if (this.#transitionTimeout) {
          clearTimeout(this.#transitionTimeout);
          this.#transitionTimeout = undefined;
        }
        this.#setSlideState(nextIndex);
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== enteringSlide) return;
        if (event.propertyName !== 'opacity') return;
        finishTransition();
      };

      enteringSlide.addEventListener('transitionend', handleTransitionEnd, { once: true });
      this.#transitionTimeout = window.setTimeout(finishTransition, 950);
    }
  }

  if (!customElements.get('ingredients-swiper')) {
    customElements.define('ingredients-swiper', IngredientsSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  class ProductTestimonialsSwiper extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      this.currentIndex = 0;
      this.slideCount = Number(this.dataset.slideCount || this.slides.length);
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed || 4000);

      if (!this.track || this.slideCount <= 1) return;

      this.bindEvents();
      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.handleResizeBound) {
        window.removeEventListener('resize', this.handleResizeBound);
      }
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      }

      this.handleResizeBound = () => this.update(false);
      window.addEventListener('resize', this.handleResizeBound);

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    goTo(index, animate = true) {
      const maxIndex = this.slideCount - 1;
      if (index < 0) {
        this.currentIndex = maxIndex;
      } else if (index > maxIndex) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }
      this.update(animate);
      this.startAutoplay();
    }

    update(animate = true) {
      if (!this.track) return;
      this.track.style.transitionDuration = animate ? '420ms' : '0ms';
      this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;
      this.slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === this.currentIndex ? 'false' : 'true');
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplay || this.slideCount <= 1) return;
      this.timer = window.setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('testimonials-swiper')) {
    customElements.define('testimonials-swiper', ProductTestimonialsSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSwiper extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      this.currentIndex = 0;
      this.slideCount = Number(this.dataset.slideCount || this.slides.length);
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed || 4000);

      if (!this.track || this.slideCount <= 1) return;

      this.bindEvents();
      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.handleResizeBound) {
        window.removeEventListener('resize', this.handleResizeBound);
      }
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1));
      }

      this.handleResizeBound = () => this.update(false);
      window.addEventListener('resize', this.handleResizeBound);

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());

      document.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        if (!this.contains(event.target)) return;
        const selectedSlide = event.target.closest('[data-slide]');
        if (!selectedSlide) return;
        const selectedIndex = Number(selectedSlide.dataset.index || 0);
        this.goTo(selectedIndex, false);
      });
    }

    goTo(index, animate = true) {
      const maxIndex = this.slideCount - 1;
      if (index < 0) {
        this.currentIndex = maxIndex;
      } else if (index > maxIndex) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }
      this.update(animate);
      this.startAutoplay();
    }

    update(animate = true) {
      if (!this.track) return;
      this.track.style.transitionDuration = animate ? '420ms' : '0ms';
      this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;
      this.slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === this.currentIndex ? 'false' : 'true');
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplay || this.slideCount <= 1) return;
      this.timer = window.setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('testimonials-swiper')) {
    customElements.define('testimonials-swiper', TestimonialsSwiper);
  }

  } catch(e) { console.error(e); }
})();
})();
